import * as actions from './actions'
import mutations from './mutations'
import * as getters from './getters'

const EmailStore = {
  state: {
    emails: []
  },
  getters,
  mutations,
  actions
}

export default EmailStore